import { render, staticRenderFns } from "./NavigationUserInfo.vue?vue&type=template&id=678cbb4a&scoped=true&"
import script from "./NavigationUserInfo.vue?vue&type=script&lang=js&"
export * from "./NavigationUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./NavigationUserInfo.vue?vue&type=style&index=0&id=678cbb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cbb4a",
  null
  
)

export default component.exports